import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog-image.component.html',
  styleUrls: ['./dialog-image.component.scss']
})
export class DialogImageComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
     }) {
     }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close('confirm'); 
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }
}
